export default "__VITE_ASSET__Dyhv0cdt__"